<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          <v-row>
            <v-col>
              <span class="headline" style="word-break: keep-all">{{
                title
              }}</span>
            </v-col>
            <v-col cols="auto">
              <v-btn icon @click="cancel"><v-icon>close</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="px-12">{{ text }}</v-card-text>
        <v-card-actions class="px-12 py-4">
          <v-spacer></v-spacer>
          <v-btn text small @click="cancel">
            {{ $t("dialog.cancel") }}
          </v-btn>
          <v-btn small color="primary" @click="okClicked">
            {{ okText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["alert", "title", "text", "okText"],
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    alert() {
      if (this.alert) {
        this.dialog = true;
      } else {
        this.dialog = false;
      }
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    okClicked() {
      this.$emit("ok", this.alert);
    },
  },
};
</script>
